import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import InnospecIcon from "./InnospecLogo";
import "../App.css";
import { useCookies } from 'react-cookie';
import mainTheme from '../Themes';
import SvgIcon from '@mui/icons-material/Menu';

function removeBeforeAndAfterFirstSlash(url: string) {
  let parts = url.split('/'); 
  let afterThirdSlash = parts.slice(3).join('/'); // Keep everything after the 3rd slash
  
  return afterThirdSlash.split('/')[0]; // Keep only the first part before any additional slashes
}

const pages = [
  { displayName: "Inicio", hrefLink: "" },
  { displayName: "Mapa", hrefLink: "map" }
  //{ displayName: "Products Usage", hrefLink: "products" }, 
  //{ displayName: "Wells", hrefLink: "wells" }
];
const settings = ["Cerrar Sesión"];

function Navbar({ username }: { username: string }) {
  const [cookies, setCookie, removeCookie] = useCookies(["authKey", "username", "customerName"]);

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  const [pfp, setPfp] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    const storedImg = localStorage.getItem("logo64");
    if (storedImg) {
      setPfp("data:image/png;base64," + storedImg);
    }
  }, ["GarbageData"]);

  // These are handles that we can use to know when the user opens/closes menus
  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSettingClick = (key: string) => {
    setAnchorElUser(null);

    if (key === "Logout" || key === "Cerrar Sesión") {
      // Logout the user by removing the cookie.
      removeCookie("authKey", { path: "/" });
      removeCookie("customerName", { path: "/" });
    }
  };

  return (
    <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: 1, borderColor: "#e7e7e7" }}>
      <Container maxWidth={false}>
        <Toolbar disableGutters>
          <IconButton
            component="a"
            href="#"
            sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}
          >
            <InnospecIcon />
          </IconButton>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-navbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>

            <Menu
              id="menu-navbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page.displayName} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">
                    <a id="page-link-text" href={"/" + page.hrefLink}>{page.displayName}</a>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <IconButton
              component="a"
              href="#"
            >
              <InnospecIcon />
            </IconButton>
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.displayName}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'black', display: 'block', backgroundColor: removeBeforeAndAfterFirstSlash(window.location.href) === page.hrefLink ? mainTheme.colors.innoBlueL : "#FFFFFF", ":hover": { backgroundColor: removeBeforeAndAfterFirstSlash(window.location.href) === page.hrefLink ? mainTheme.colors.innoBlueL : "#e9e9e9" } }}
              >
                <a id="page-link-text" href={"/" + page.hrefLink}>{page.displayName}</a>
              </Button>
            ))}
          </Box> 

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Abrir ajustes">
              <IconButton
                onClick={handleOpenUserMenu}
                sx={{
                  p: 0,
                  width: 80,
                  height: 80,
                  display: 'flex',
                  justifyContent: 'flex-end', // aligns inner content to the right
                  alignItems: 'center',
                  marginRight: "26px"
                }}
              >{pfp ?
                <Box
                  component="img"
                  src={pfp || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="}
                  alt="icon"
                  sx={{
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%) scale(1.4)', // scale up
                    width: "100%",
                    height: "100%",
                    objectFit: 'contain',
                    pointerEvents: 'none',
		    opacity: pfp ? 100 : 0
                  }}
                />
		:
		<Avatar alt={"Super Admin"} sx={{ backgroundColor: mainTheme.colors.innoBlue }}>
                  {"S"}
                </Avatar>
	       }
              </IconButton>
            </Tooltip>

            <Menu
              sx={{ mt: '45px' }}
              id="menu-navbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem key="LoggedInUser" disabled>
                <Typography textAlign="center">{`Iniciado sesión como ${cookies?.customerName ? cookies.customerName : "None"}`}</Typography>
              </MenuItem>
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={() => handleSettingClick(setting)}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Navbar;
